import React from 'react';
import Select from 'react-select';

// Selector styles
const groupStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
};

const groupBadgeStyles = {
backgroundColor: '#EBECF0',
borderRadius: '2em',
color: '#172B4D',
display: 'inline-block',
fontSize: 12,
fontWeight: 'normal',
lineHeight: '1',
minWidth: 1,
padding: '0.16666666666667em 0.5em',
textAlign: 'center',
};

const formatGroupLabel = (data) => (
    <div style={groupStyles}>
        <span>{data.label}</span>
        <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
);



function Selector(props) {

    // eDNA data
    const contentOptions = props.options;
    // console.log(contentOptions);

    var dbShowList = contentOptions.filter(function (el)
    {
        return el.type === 'Show';
    });

    var dbMovieList = contentOptions.filter(function (el)
    {
        return el.type === 'Movie';
    });

    var dbNetworkList = contentOptions.filter(function (el)
    {
        return el.type === 'Network';
    });

    console.log(dbNetworkList)

    const groupedContentOptions = [
        {
            label: 'Show',
            options: dbShowList,
        },
        {
            label: 'Movie',
            options: dbMovieList,
        },
        {
            label: 'Network',
            options: dbNetworkList,
        },
        ];


    return (
        <div className='grid justify-items-center px-12 pt-2 mt-1'>
            <div className={props.width ? props.width : 'w-60'}>
                <Select
                    placeholder="Please select..."
                    noOptionsMessage={()=>{return "Loading..."}}
                    value={props.selectedOption}
                    onChange={props.handleChange}
                    // options={contentOptions}
                    options={groupedContentOptions}
                    formatGroupLabel={formatGroupLabel}
                />
            </div>
        </div>

     );
}

export default Selector;
